import React, {useEffect, useState} from 'react';
import {Box, Text} from '@chakra-ui/react';
import {useRecoilValue} from 'recoil';
import PortfolioNav, {companyViewState} from '../nav';
import PortfolioListGridView from './gridView';
import PortfolioListListView from './listView';
import {AnimatePresence, motion} from 'framer-motion';
import axios from "axios";
import {useParams} from "react-router-dom";
import Container from "../../../../components/Container";
import PortfolioDetail from "../../../Portfolio/Components/company-detail";

const ListWrapper = motion(Box);

const PortfolioList = () => {
    const {slug} = useParams();
    const view = useRecoilValue(companyViewState);
    const [companiesData, setCompaniesData] = useState(undefined)

    /*
    useEffect(() => {
        const fetchCompanies = async () => {
            const response = await axios.get(`/wp-admin/admin-ajax.php?action=get_companies&team_slug=${slug}`).then(resp => {
                return resp.data;
            });
            setCompaniesData(response)
        }
        fetchCompanies()
    }, [slug])
    */

    const appliedInvestmentStatus = React.useMemo(() => {
        return companiesData?.filter((fid) => {
            const isInvestmentStatus = fid.investment_status?.find(
                (item) => item.name === 'Active',
            );

            if (!!isInvestmentStatus) {
                return fid;
            }
            return null;
        });
    }, [companiesData]);

    const appliedAlumni = React.useMemo(() => {
        return companiesData?.filter((fid) => {
            const isAlumni = fid.investment_status?.find((item) => item.name === 'Alumni');
            if (!!isAlumni) {
                return fid;
            }
            return null;
        });
    }, [companiesData]);

    if (!companiesData || companiesData.length < 1 || (appliedInvestmentStatus?.length < 1 && appliedAlumni?.length < 1)) {
        return <></>
    }
    return (
        <>
            <PortfolioNav/>
            <Box borderX={'1px'} borderColor={'brandAlpha.200'} pb={10}>
                <Container>
                    <AnimatePresence>
                        {view === 'grid' ? (
                            <ListWrapper
                                initial={{opacity: 0}}
                                animate={{opacity: 1}}
                                exit={{opacity: 0}}
                                transition={{duration: 0.4}}
                                key={0}
                                px={['2.5', '5']}
                                position={'relative'}
                            >
                                {appliedInvestmentStatus?.length > 0 &&
                                    <>
                                        <Text
                                            lineHeight={'23.4px'}
                                            fontSize={'lg'}
                                            textAlign={'left'}
                                            color={'#353535'}
                                            mb={'40px'}
                                        >
                                            Active
                                        </Text>
                                        <PortfolioListGridView companies={appliedInvestmentStatus}/>
                                    </>
                                }
                                {appliedAlumni?.length > 0 &&
                                    <>
                                        <Text
                                            lineHeight={'23.4px'}
                                            fontSize={'lg'}
                                            textAlign={'left'}
                                            color={'#353535'}
                                            mb={'40px'}
                                        >
                                            Alumni
                                        </Text>
                                        <PortfolioListGridView companies={appliedAlumni}/>
                                    </>
                                }
                            </ListWrapper>
                        ) : (
                            <ListWrapper
                                key={1}
                                initial={{opacity: 0}}
                                animate={{opacity: 1}}
                                exit={{opacity: 0}}
                                transition={{duration: 0.4}}
                                position={'relative'}
                            >
                                {appliedInvestmentStatus?.length > 0 &&
                                    <>
                                        <Text
                                            lineHeight={'23.4px'}
                                            fontSize={'lg'}
                                            textAlign={'left'}
                                            color={'#353535'}
                                            mb={'40px'}
                                            ml={'1.5rem'}
                                        >
                                            Active
                                        </Text>
                                        <PortfolioListListView companies={appliedInvestmentStatus}/>
                                    </>
                                }
                                {appliedAlumni?.length > 0 &&
                                    <>
                                        <Text
                                            lineHeight={'23.4px'}
                                            fontSize={'lg'}
                                            textAlign={'left'}
                                            color={'#353535'}
                                            mb={'40px'}
                                            ml={'1.5rem'}
                                            mt={'40px'}
                                        >
                                            Alumni
                                        </Text>
                                        <PortfolioListListView companies={appliedAlumni}/>
                                    </>
                                }
                            </ListWrapper>
                        )}
                    </AnimatePresence>
                    <PortfolioDetail companies={companiesData} fromBio={true}/>
                </Container>
            </Box>
        </>
    );
};

export default PortfolioList;
